export default "/34887f8f847f5d202a469a9dd4881160882f8c6b/062e30a7ac6b62636e98a277a6442dbf.svg";